import React from 'react'
import { ListGroup, ListGroupItem, ListGroupItemHeading, Table } from 'reactstrap'
import Loader from 'react-loader-spinner'
import { Controller, User } from '../../models'
import { WS_URL, getController, getTeam, planlist } from "../../api"
import { authRedirect, loadUser } from "../../dataHelpers/authenticationHelpers"
import { getMySubscriptionPlan, getPaymentHistory } from "../../dataHelpers/subscriptionHelpers"
import Websocket from "react-websocket"
import { subscriptionHelpers } from '../../dataHelpers'
import { ErrorModal } from './'
import { SUBS_PLAN_NOT_ASSIGN, PAY_DATA_NOT_FOUND, NOT_FOUND } from '../../constants'
import '../../stylesheets/odometer-theme-default.css'
import '../../stylesheets/ControllerDashboard.css'


class ControllerSubscriptionPanel extends React.Component {
    constructor(props) {
        super(props)
        let {token, history, match} = props

        this.state = {
            controller: null,
            loading: false,
            errors: [],
            subscriptionDetails: null,
            subsPlanName: '',
            isSeasonedPlan: '',
            subsPaymentData: [],
            dealersList: [],
            remainingDays: 0,
            token,
            subsPlanYear: '',
            startDate:'',
            endDate:'',
        }

        this.history = history
        this.user = new User()
        this.controllerID = null
        if (match && match.params && match.params.controller_id) {
            this.controllerID = match.params.controller_id
        }
        this.fetchController = this.fetchController.bind(this)
        this.getPaymentData = this.getPaymentData.bind(this)
        this.getSubscriptionData = this.getSubscriptionData.bind(this)
        this.getDealers = this.getDealers.bind(this)
        this.getRemainingdays = this.getRemainingdays.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.dismissError = this.dismissError.bind(this)
    }

    async componentDidMount() {
        let {token} = this.state

        if (this.controllerID && token) {
            this.user = await loadUser(token)
            if (this.user && !this.user.canViewControllers) {
                authRedirect('/unauthorized', this.history)
            }

            this.fetchController(token)
            this.getDealers(token)
        }
    }

    async componentWillReceiveProps(props) {
        let {token, history, match} = props
        this.setState({token, history, match})

        if (match && match.params && match.params.controller_id) {
            this.controllerID = match.params.controller_id
        }

        if (this.controllerID && token) {
            this.user = await loadUser(token)
            if (this.user && !this.user.canViewControllers) {
                authRedirect('/unauthorized', this.history)
            }

            this.fetchController(token)
            this.getDealers(token)
        }
    }

    async getDealers(token) {
        try {
            let dealersData = await subscriptionHelpers.getDealersList(token)
            if (!dealersData.error) {
                this.setState({ dealersList: dealersData.map((e) => e.email) })
            } else {
                this.setState({ errors: [dealersData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async fetchController(token) {
        let {teamName} = this.state
        try {
            let controllerId
            if (this.controllerID) {
                controllerId = this.controllerID
                if (controllerId) {
                    await this.getRemainingdays(token, controllerId)
                    await this.getSubscriptionData(token, controllerId)
                    await this.getPaymentData(token, controllerId)
                }
            } else {
                authRedirect('/', this.history)
            }
            let controller = await getController(token, controllerId)
            if (controller.team) {
                let team = await getTeam(token, controller.team, 'pico')
                teamName = team.name
            }
            await this.setState({ controller, teamName })
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    async getRemainingdays(token, controllerId) {
        try {
            let controller = await getController(token, controllerId)
            if (!controller.error) {
                this.setState({ remainingDays: controller.freeDaysRemaining })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getSubscriptionData(token, controllerId) {
        try {
            let subscriptionData = await getMySubscriptionPlan(token, controllerId)
            if (!subscriptionData.error) {
                if (subscriptionData.subscription_plan) {
                    
                    let subsPlan = await planlist(token)
                    {
                        (subsPlan.map((plan) =>
                            (plan.id == subscriptionData.subscription_plan ? this.setState({ subsPlanName: plan.name,
                                 isSeasonedPlan: plan.is_seasoned,
                                  subsPlanYear: plan.SubscriptionPlanPrice_set.length > 0? plan.SubscriptionPlanPrice_set[0].subscription_year: null }) : '')
                        ))
                    }
                }
                this.setState({ subscriptionDetails: subscriptionData,startDate:subscriptionData.start_date,endDate:subscriptionData.en})
            } else if (!subscriptionData.error || !subscriptionData.error.title || subscriptionData.error.title !== NOT_FOUND) {
                this.setState({errors: [subscriptionData.error]})
            }
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    async getPaymentData(token, controllerId) {
        try {
            let paymentDataResponse = await getPaymentHistory(token, controllerId)
            if (!paymentDataResponse.error) {
                if (paymentDataResponse.length > 0) {
                    await this.setState({ subsPaymentData: paymentDataResponse, loading: false })
                } else {
                    //let appError = new AppError("No Found", `Payment history not found for this controller.`)
                    //await this.setState({errors: [appError], loading: false, paymentHistoryData : ''})
                }
            } else {
                this.setState({ errors: [paymentDataResponse.error] })
            }
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors })
    }

    async handleWebSocketResponse(data) {
        let controller = Controller.fromAPIObject(JSON.parse(data))
        let {token, teamName} = this.state
        if (controller.team) {
            let team = await getTeam(token, controller.team, 'pico')
            teamName = team.name
        }
        this.setState({ controller, teamName })
    }

    IsJsonString(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }

    render() {
        let controller = this.state.controller || new Controller()
        let { token, errors, loading, teamName, subscriptionDetails, subsPlanName, isSeasonedPlan,
             subsPaymentData, dealersList, remainingDays, subsPlanYear,is_subscription_trial ,startDate} = this.state
    //  for starting date format
        let concatdate=new Date(startDate)
        
        let sday=("0" + (concatdate.getMonth() + 1)).slice(-2)
        let sdate=sday+'-'+concatdate.getDate()+'-'+concatdate.getFullYear()
            return loading ?
            <div className="m-5 align-content-center text-center justify-content-center"><Loader type="TailSpin" width={60} height={60} /></div> :
                    <div className="row bg-light border">
                        <div className="col-12 col-md-6">
                            <ListGroup className="align-self-center m-3 text-left">
                                <ListGroupItem className="bg-light">
                                    <ListGroupItemHeading className="text-center font-weight-bold">Subscription Details</ListGroupItemHeading>
                                </ListGroupItem>
                                {subscriptionDetails ?
                                    <div>
                                        <ListGroupItem><strong>Subscription Plan :</strong> {subsPlanName}</ListGroupItem>
                          <ListGroupItem><strong>Team :</strong> {teamName}</ListGroupItem>
                                        {/* <ListGroupItem><strong>Start Date :</strong> {new Date(subscriptionDetails.start_date).toISOString().slice(0, 10)}</ListGroupItem> */}
                                        <ListGroupItem><strong>Start Date :</strong> {sdate}</ListGroupItem>
                                        {subscriptionDetails.is_trial?
                                            <div>
                                                <ListGroupItem><strong>Remaining days : </strong>
                                                    {subscriptionDetails.remaining_days == null ? '0' : subscriptionDetails.remaining_days}
                                                </ListGroupItem>
                                                <ListGroupItem><strong>Extended days :</strong> {subscriptionDetails.extended_days}</ListGroupItem>
                                            </div> :!isSeasonedPlan?
                                               <ListGroupItem><strong>Extended days :</strong> {subscriptionDetails.extended_days}</ListGroupItem>:
                        <ListGroupItem><strong>End Date :</strong> {//subscriptionDetails.extended_date ? subscriptionDetails.extended_date :
                             //subscriptionDetails.start_date.slice(0,4)
                              '12-31-'+subsPlanYear}</ListGroupItem>
                                        }
                                    </div>
                                    : <div>
                                        <ListGroupItem>{SUBS_PLAN_NOT_ASSIGN}</ListGroupItem>
                                    </div>
                                }

                            </ListGroup>
                        </div>
                        <div className="col-12 col-md-6 pay-mar-top">
                            <ListGroup className="align-self-center">
                                <ListGroupItem className="bg-light">
                                    <ListGroupItemHeading className="text-center font-weight-bold">Payment Details</ListGroupItemHeading>
                                </ListGroupItem>
                                
                                {<div class="table-responsive">
                                    <Table className="customTable">
                                        <tbody>
                                        <tr>
                                            <th>Transaction ID</th>
                                            <th>Paid By</th>
                 
                                            <th>Amount</th>
                                            <th>Payment Date</th>
                                        </tr>
                                        {(subsPaymentData && subsPaymentData.length > 0) ? subsPaymentData.map((p, idx) => {
                                                let detail = this.IsJsonString(p.detail)
                                                return (
                                                    <tr key={`${p.id}-${idx}`}>
                                                        <td>{p.transaction_id}</td>
                                                        <td>{p.paid_by}</td>
                                                        <td>
                                                            {
                                                                dealersList.indexOf(p.paid_by) !== -1 ? '--' : (detail ? ('$ ' + (detail.amount) / 100) : '')
                                                            }
                                                        </td>
                                                        <td>{new Date(p.payment_date).toISOString().slice(0, 10)}</td>
                                                    </tr>
                                                )
                                            }) :
                                            <tr>
                                                <td colSpan='4'>{PAY_DATA_NOT_FOUND}</td>
                                            </tr>}
                                        </tbody>
                                    </Table>
                                </div>
                                }

                            </ListGroup>
                        </div>
                        {(errors.map((appError, idx) =>
                            <ErrorModal key={idx} modal={true} toggle={() => (this.dismissError(appError))} text={appError.text} title={appError.title} />
                        ))}
                        {(controller.id ?
                            <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                                       onMessage={this.handleWebSocketResponse} /> : null)}
                    </div>
    }
}
export default ControllerSubscriptionPanel



// WEBPACK FOOTER //
// ./src/components/ui/ControllerSubscriptionPanel.js